<template>
  <!-- Header(상단) / Content(좌·메인) / SideNav(우측, 기본 숨김) 3분할 -->
  <div class="app-shell" :class="{ 'nav-open': sideNavVisible }">
    <header class="app-shell__header">
      <AppHeader @toggle-sidenav="toggleSideNav" />
    </header>
    <main class="app-shell__content">
      <AppContent />
    </main>
    <aside class="app-shell__sidenav">
      <AppSideNav :visible="sideNavVisible" @navigate="toggleSideNav" />
    </aside>

    <!-- 전역 모달 (메뉴 액션 등으로 열림) -->
    <GlobalModalHost />
  </div>
</template>

<script>
import AppHeader from "./AppHeader.vue";
import AppContent from "./AppContent.vue";
import AppSideNav from "./AppSideNav.vue";
import GlobalModalHost from "@/components/common/GlobalModalHost.vue";

export default {
  name: "AppShell",
  components: { AppHeader, AppContent, AppSideNav, GlobalModalHost },
  data() {
    return {
      // SideNav 기본값 = 숨김(Invisible). Header 토글로 표시.
      sideNavVisible: false,
    };
  },
  watch: {
    // 협업 Space(RemoteZone) 진입 시 우측 사이드 메뉴가 열려 있으면 닫기
    $route(to) {
      if (to.name === "RemoteZone" && this.sideNavVisible) {
        this.sideNavVisible = false;
      }
    },
  },
  methods: {
    toggleSideNav() {
      this.sideNavVisible = !this.sideNavVisible;
    },
  },
};
</script>

<style scoped>
.app-shell {
  display: grid;
  grid-template-columns: 1fr 0; /* 우측 SideNav 기본 0 (숨김) */
  grid-template-rows: auto 1fr;
  grid-template-areas:
    "header sidenav"
    "content sidenav";
  /* 모바일 주소창을 제외한 실제 보이는 높이(dvh). 미지원 브라우저는 100vh 폴백.
     100vh 만 쓰면 모바일에서 화면보다 커져 하단 콘텐츠가 주소창 뒤로 밀리고 스크롤이 막힘. */
  height: 100vh;
  height: 100dvh;
  background: rgb(var(--c-base));
  color: rgb(var(--c-content));
  transition: grid-template-columns 0.2s ease;
}
.app-shell.nav-open {
  grid-template-columns: 1fr 260px;
}
.app-shell__header {
  grid-area: header;
}
.app-shell__content {
  grid-area: content;
  overflow: hidden;
  min-height: 0;
}
.app-shell__sidenav {
  grid-area: sidenav;
  overflow: hidden;
}
</style>
